require('../../modules/es7.object.entries');
module.exports = require('../../modules/$.core').Object.entries;


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/~/core-js/library/fn/object/entries.js
 ** module id = 444
 ** module chunks = 0 1 2 10 11 17 19 20 26 33
 **/